(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/caretech/caretech-restrictions/assets/javascripts/caretch-restrictions.js') >= 0) return;  svs.modules.push('/components/caretech/caretech-restrictions/assets/javascripts/caretch-restrictions.js');
'use strict';

var _svs$caretech$caretec;
svs.caretech = svs.caretech || {};
svs.caretech.caretech_restrictions = svs.caretech.caretech_restrictions || {};
const logger = svs.core.log.getLogger('components:caretech-restrictions');
const restrictions = (_svs$caretech$caretec = svs.caretech.caretech_restrictions) === null || _svs$caretech$caretec === void 0 ? void 0 : _svs$caretech$caretec.data;
const careTechReasonTypesEnum = {
  DIALOG: 'Dialog',
  MESSAGE: 'Message'
};
const careTechRestrictionTypesEnum = {
  HIT_TIME_LIMIT: 'hit_time_limit',
  LONG_SESSION: 'Long_session'
};
function displayActiveRestrictionDialog(limitData) {
  svs.caretech.caretech_restrictions.activeRestriction(limitData);
}
function displayCaretechCheck(restrictionDetails) {
  const checkData = {
    id: restrictionDetails.dialogProperties.dialogType,
    mandatory: restrictionDetails.dialogProperties.mandatory === true ? 'true' : 'false',
    interaction_Id: restrictionDetails.interactionId
  };
  svs.caretech.caretech_checks.show(checkData);
}
function testGetCaretechRestriction(restrictionId) {
  switch (restrictionId) {
    case String("test".concat(careTechRestrictionTypesEnum.HIT_TIME_LIMIT)):
      return {
        type: careTechRestrictionTypesEnum.HIT_TIME_LIMIT,
        data: '08:15'
      };
    case String("test".concat(careTechRestrictionTypesEnum.LONG_SESSION)):
      return {
        type: careTechRestrictionTypesEnum.LONG_SESSION,
        data: {
          id: 'LongSession',
          mandatory: 'true'
        }
      };
    default:
      return null;
  }
}
async function fetchRestriction(vertical) {
  try {
    const {
      response
    } = await svs.core.jupiter.callAsync({
      method: 'GET',
      path: "/caretech/1/customer/active-restriction?vertical=".concat(vertical)
    });
    if (response) {
      return response.response;
    }
  } catch (error) {
    logger.warn('Failed to fetch active restriction', error);
    return error;
  }
  return null;
}
async function getCaretechRestriction(vertical) {
  const restrictionDetails = await fetchRestriction(vertical);
  if (restrictionDetails) {
    logger.info('Got caretech restriction to handle');
    switch (restrictionDetails.careTechReason) {
      case careTechReasonTypesEnum.DIALOG:
        displayCaretechCheck(restrictionDetails);
        return true;
      case careTechReasonTypesEnum.MESSAGE:
        displayActiveRestrictionDialog(restrictionDetails);
        return true;
      default:
        break;
    }
    return false;
  }
  logger.warn("Did not find any action for restriction: ".concat(restrictions));
  return false;
}
function HasCareTechRestriction(vertical) {
  if (svs.core.detect.feature('ft-caretech-uc2-dialog')) {
    let hasRestriction = false;
    if (vertical) {
      hasRestriction = getCaretechRestriction(vertical);
    }
    return hasRestriction;
  }
  return false;
}
svs.caretech.caretech_restrictions = {
  test: {
    testGetCaretechRestriction
  },
  HasCareTechRestriction
};

 })(window);